module.exports = __webpack_public_path__ + "img/vi.9af6bfa.svg";